import { CookieConsent, CoreModalDialog, FinallyRejectedModal } from '@components'
import AdminDashboard from '@dashboard/views/AdminDashboard'
import StaffDashboard from '@dashboard/views/StaffDashboard'
import { NewsModal } from '@views/dashboard/NewsModal'
import { WelcomeModal } from '@views/dashboard/WelcomeModal'
import {
  CustomerRoles,
  isOwnerOrAdministrator,
  OnboardingStatuses,
  selectCurrentUserRole,
  selectInitialEmailVerification,
  useAppSelector,
  useMerchantQry,
  useNewsQry
} from 'mmfintech-backend-api'
import { GlobalContext, isValidArray, isValidObject, tr } from 'mmfintech-commons'
import { useCallback, useContext, useEffect } from 'react'
import { useCookies } from 'react-cookie'

const Dashboard = () => {
  const { modalShow } = useContext(GlobalContext)

  const customerRole = useAppSelector(selectCurrentUserRole)

  const [modalCookies, setModalCookies] = useCookies(['cookie.modals'])

  const { merchant } = useMerchantQry()
  const initialEmailVerification = useAppSelector(selectInitialEmailVerification)

  const { news } = useNewsQry()

  const showWelcomeModal = useCallback(() => {
    modalShow({
      header: tr('FRONTEND.WELCOME.MODAL.HEADING', 'Welcome to The Kingdom Bank!'),
      content: <WelcomeModal />,
      options: {
        closeOnClickOutside: false,
        closeOnEscape: false,
        hideCloseIcon: true
      }
    })
  }, [modalShow])

  const showNewsModal = useCallback(() => {
    modalShow({
      options: {
        closeOnClickOutside: true,
        closeOnEscape: true,
        customSize: 48
      },
      header: tr('FRONTEND.NEWS.HEADER', 'News'),
      content: <NewsModal news={news} />
    })
  }, [modalShow])

  useEffect(() => {
    if (initialEmailVerification) {
      showWelcomeModal()
    } else if (isValidArray(news)) {
      showNewsModal()
    }
  }, [initialEmailVerification, news])

  return (
    <>
      {merchant?.onboardingStatus === OnboardingStatuses.REJECTED_FINAL &&
        !isValidObject(modalCookies['cookie.modals']) && (
          <CoreModalDialog
            header={tr('FRONTEND.ONBOARDING.FINALLY_REJECTED_LABEL', 'Finally rejected')}
            visible={!isValidObject(modalCookies['cookie.modals'])}
            options={{
              hideCloseIcon: true
            }}
            content={<FinallyRejectedModal setCookie={setModalCookies} cookieConsent={CookieConsent} />}
          />
        )}
      {isOwnerOrAdministrator(customerRole) && <AdminDashboard />}
      {customerRole === CustomerRoles.STAFF && <StaffDashboard />}
    </>
  )
}

export default Dashboard
